<template>
  <div class="vz-order-seo-footer">
    <div class="public-container public-container-mobile py-70">
      <h2 class="vz-text-align-left">
        Как рассчитать стоимость доставки в калькуляторе
      </h2>
      <p>
        Транспортная компания Возовоз предлагает грузоперевозки для частных и юридических 
        лиц, малого и среднего бизнеса, интернет-магазинов, производителей товаров и др.
        <br>
        Перевозка производится по принципу "Сборного груза", по которому принятый для 
        доставки груз консолидируется на складе для определения оптимального маршрута 
        и перевозится вместе с грузом других клиентов. В калькуляторе по умолчанию 
        рассчитывается стоимость именно сборной перевозки. 
      </p>
      <p>
        В случае если для забора/доставки вашего груза до/от терминала ТК требуется отдельный 
        транспорт, то вы можете выбрать услугу «Выделенная машина» в разделе калькулятора "Забор 
        груза/Отвоз груза".
        <br>
        После оформления заказа клиенту сообщаются данные водителя в день, предшествующий дате 
        отправления/доставки, до 17:00.
      </p>

      <h3>Расчет стоимости основных и дополнительных услуг</h3>
      <p>
        В расчете учитываются все услуги перевозчика, поэтому финальное значение стоимости доставки 
        будет максимально точным.
      </p>
      <h4 class="mt-30">Основными услугами являются:</h4> 
      <ul class="public-list public-list-square">
        <li v-for="item, i in items1" :key="i">
          <span>{{ item }}</span>
        </li>
      </ul>
      <p class="mt-10">
        Основные услуги входят в базовую стоимость доставки.
      </p>
      <h4 class="mt-30">В дополнительные услуги входят:</h4>
      <ul class="public-list public-list-square">
        <li v-for="item, i in items2" :key="i">
          <span>
            {{ item.text }}
            <nuxt-link
              v-if="item.link"
              :to="item.link.to"
              target="_blank"
            >
              {{ item.link.title }}
            </nuxt-link>
          </span>
        </li>
      </ul>
      <p class="mt-10">
        Детализация по ценам всех услуг, которые формируют общую стоимость перевозки, выводится в 
        окне калькулятора справа. Тем самым формирование общей цены грузоперевозки становится 
        понятным и прозрачным.
      </p>
      <h3>Дополнительные параметры расчета</h3>
      <p>
        Сюда включены специальные требования к транспорту, которые учтены в калькуляторе 
        грузоперевозки.
      </p>
      <ul class="public-list public-list-square">
        <li v-for="item, i in items3" :key="i">
          <span>{{ item }}</span>
        </li>
      </ul>
      <p>
        Дополнительно можно указать ограничения по высоте и ширине кузова, необходимость задней 
        загрузки без гидроборта и растентовки, а также наличие крепёжных ремней и паллет - это 
        бесплатные опции.
      </p>

      <h3>Расчет отправки нестандартного груза</h3>
      <p>
        Если параметры одного грузового места превышают: длина – 0.2 м, ширина – 0.2 м, высота – 0.2 м 
        и вес – 2.5 кг, груз является нестандартным. Чтобы рассчитать стоимость перевозки груза 
        нестандартных размеров, укажите в калькуляторе его габариты.
        <br>
        Груз считается негабаритным, если его длина равна или больше 4 м, вес более 500 кг и хотя бы одно 
        из значений длины, ширины, высоты превышает 1.2x0.8x1.75 м соответственно. Стоимость перевозки
        <nuxt-link :to="{ name: 'shippingtypes-oversized' }" target="_blank">негабаритного груза</nuxt-link> 
        рассчитывается с наценкой от 20 до 50%.
      </p>

      <h3>Расчет доставки документов</h3>
      <p>
        Чтобы рассчитать стоимость отправки документов, необходимо выбрать в калькуляторе тип "Корреспонденция". 
        Параметры размеров, веса, объема заполнять не надо. Документы отправляются 
        отдельным местом, упакованные в сейф-пакет — включен в стоимость транспортировки.
        <br>
        Доставка документов возможна, если их размеры не превышают 210x297 мм (А4), а вес 
        не более 200 г. 
      </p>

      <h3>Индивидуальное обслуживание</h3>
      <p>
        При Индивидуальном обслуживании заказ будет вести персональный менеджер, который будет сопровождать 
        весь процесс грузоперевозки и, в случае необходимости, предоставит дополнительные сервисы:
      </p>
      <ul class="public-list public-list-square">
        <li v-for="item, i in items4" :key="i">
          <span>{{ item }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
const items1 = [
  'перевозка между городами;',
  'складская обработка.'
]

const items2 = [
  {
    text: 'доставка груза до и от терминала транспортной компании;',
  },
  {
    text: 'доставка от адреса до адреса;',
  },
  {
    text: 'дополнительная упаковка, например, жесткая упаковка. Клиент может самостоятельно упаковать груз в защитную жесткую упаковку или заказать услугу у транспортной компании. Перечень грузов, подлежащих ',
    link: {
      title: 'обязательной защитной жесткой упаковке;',
      to: { name: 'wrapping-hard-box' }
    }
  },
  {
    text: 'страхование;'
  }, 
  {
    text: 'возврат сопроводительных документов;'
  },
  {
    text: 'погрузка-разгрузка.'
  }
]

const items3 = [
  'Боковая загрузка;',
  'Верхняя загрузка;',
  'Гидроборт;',
  'Манипулятор;',
  'Открытая машина.'
]

const items4 = [
  'контроль оплаты и срока доставки;',
  'перевозку нестандартного груза и др. опции.'
]
</script>

<style lang="scss" scoped>
.vz-order-seo-footer {
  background-color: $box-gray;

  h2, h3, h4 {
    font-weight: 400;
  }

  :deep(h3) {
    margin-top: 50px;
    margin-bottom: 10px;
  }

  a {
    text-decoration: underline;
  }
}
</style>
